<template>
  <section class="text-center">
    <div class="max-w-3xl mx-auto">
      <h2 class="text-3xl font-bold mb-4">准备好探索恋爱关系的真相了吗？</h2>
      <p class="text-lg text-gray-600 mb-8">
        通过科学的评估工具，深入了解恋爱中的占有欲特点，促进更健康和谐的亲密关系。
      </p>
      <div class="flex flex-col sm:flex-row gap-4 justify-center">
        <button @click="handleStartAssessment('self')" class="btn-primary">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5">
            <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path>
          </svg>
          立即开始测评
        </button>
        <router-link to="/guide" class="btn-secondary">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5">
            <path d="M12 7v14"></path>
            <path d="M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z"></path>
          </svg>
          了解更多信息
        </router-link>
      </div>
    </div>

    <!-- 激活码验证对话框 -->
    <ActivationCodeDialog 
      :show="showActivationDialog"
      :target-route="targetRoute"
      @close="handleActivationClose"
    />
  </section>
</template>

<script>
import { isActivated } from '@/utils/activationUtils'
import ActivationCodeDialog from './ActivationCodeDialog.vue'

export default {
  name: 'CTASection',
  components: {
    ActivationCodeDialog
  },
  data() {
    return {
      showActivationDialog: false,
      targetRoute: ''
    }
  },
  methods: {
    handleStartAssessment(type) {
      // 检查是否已激活
      if (isActivated()) {
        // 已激活，直接跳转
        this.$router.push(`/assessment/start?type=${type}`)
      } else {
        // 未激活，显示激活码对话框
        this.targetRoute = `/assessment/start?type=${type}`
        this.showActivationDialog = true
      }
    },
    
    handleActivationClose() {
      this.showActivationDialog = false
    }
  }
}
</script>

